(ns web3.roots.app
  (:require web3.react
            [web3.tracking.sentry]
            [web3.external-utils]
            [web3.tracking.sentry :as sentry]
            [web3.auth.okta :as okta]
            [web3.auth.auth0 :as auth0]
            [web3.errors :as err]
            [web3.re-frame.interceptors :as intr]
            [web3.screens.root :as root]
            [web3.routing.core :as routing]
            [web3.dev-utils]
            [web3.persistence.local :as local]
            [reagent.core :as reagent]
            [re-frame.core :as rf]
            [day8.re-frame.async-flow-fx]
            [web3.log :as log :include-macros true]
            [web3.forms.validation]
            [web3.components.intercom :as intercom]
            [web3.components.branch :as branch]
            [web3.tracking]             ;; side to register fxs
            [web3.ui-state :as state]
            [re-frame-simple.db :as db]
            [web3.utils :as utils]
            [web3.routers.intercom :as intercom-r]
            [web3.routers.app :as app-r]
            [web3.routers.drawer :as drawer-r]
            [web3.routers.pro :as pro-r]
            [web3.view :as v]
            [web3.components.widgets :as w]
            [web3.env :as env]))

;; useful for targeting browsers via css, eg.
;; html[data-useragent*='MSIE '] { ... }
(.. js/document
    -documentElement
    (setAttribute "data-useragent" (.-userAgent js/navigator)))

;; ========== Render ==========

(defn render
  []
  (reagent/render [root/try-root] (js/document.getElementById "web3")))

(intr/reg-event-fx
  :do/render
  (fn [cofx _]
    (js/setTimeout render 0)
    nil))

(swap! intr/mixpanel-blacklist conj :do/render)

;; ========== Boot Flow ==========

(defn boot-flow
  []
  {:id :boot-flow
   :db-path [:async-flows :boot]
   :first-dispatch [:do/boot]
   :rules [;; render the app _after_ initialization
           {:when :seen?
            :events :do/boot
            :dispatch-n [[:do/render]]}
           ;; start the auth-flow when required
           {:when :seen?
            :events [:do/auth.require-auth]
            :dispatch [:do/auth.start-flow]}]})

(def maybe-require-auth
  (rf/->interceptor
    :id :app/handle-route
    :after
    (fn [context]
      (let [[_ resolved-routers] (-> context :coeffects :event)
            require-auth? (-> (:router/root resolved-routers)
                              :view
                              (v/class-get :allow-public)
                              (not))]
        (cond-> context
                require-auth?
                (update-in [:effects :dispatch-n] conj [:do/auth.require-auth]))))))

(def track-pageview
  (rf/->interceptor
    :id :app/handle-route
    :after
    (fn [context]
      (assoc-in context [:effects :tracking/pageview]
                {:path (.. js/window -location -pathname)
                 :referrer (or (-> context :coeffects :db :document/referrer)
                               (.-referrer js/document))}))))

(intr/reg-event-fx
  :do/boot
  (fn [{:keys [db]} _]
    (log/time-start :debug "boot-flow")
    (sentry/init)
    (branch/init)
    @state/listen-window!


    (auth0/init-auth-fx)

    (db/assoc! :centriq/client-name "web")

    (routing/init!
      {:interceptors [maybe-require-auth
                      track-pageview]
       :routers #:router{:content-modal app-r/content-modal
                         :form-modal [app-r/form-modal
                                      pro-r/form-modal]
                         :drawer [drawer-r/router
                                  pro-r/drawer]
                         :intercom intercom-r/router
                         :root [app-r/root
                                pro-r/root]}
       :handler/not-found w/not-found})

    (intercom/init)

    (utils/on-reload ::render render)
    (utils/on-reload ::clear-errors #(db/update! :errors dissoc :router/root))
    {:db (assoc-in db [:session :id] (str (random-uuid)))}))

;; ========== Init ==========

(intr/reg-event-fx
  :app/boot
  (fn [_ _]
    {:async-flow (boot-flow)}))

(swap! intr/mixpanel-blacklist conj :app/boot)

(defn ^:export init []
  (rf/dispatch-sync [:app/boot]))